export enum AddOnPath {
  REVIEW = 'review/:adjustmentId',
}
